"use client";

import Image from "next/image";

interface TextArrowButtonProps {
  label: string;
  onClick: () => void;
  arrowIcon?: string;
  className?: string;
  testId?: string;
}

/**
 * Reusable button with text and arrow icon
 * Used in landing page sections: EditorialGrid, BrandDiscovery, BrandRequest, etc.
 */
export function TextArrowButton({
  label,
  onClick,
  arrowIcon = "/icons/arrow-right.svg",
  className = "",
  testId,
}: TextArrowButtonProps) {
  return (
    <button
      className={`flex items-center gap-[8px] transition-opacity hover:opacity-70 ${className}`}
      onClick={onClick}
      data-testid={testId}
    >
      <span className="text-overline text-ink">{label}</span>
      <div className="flex-shrink-0">
        <Image src={arrowIcon} alt="" width={14} height={14} />
      </div>
    </button>
  );
}
